import moment from 'moment';
import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ReactExport from 'react-data-export';
import ReporteEgresoStats from './ReporteProductosMovStats';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ReporteMovAlmacenProductos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reporteEgreso: [],
            estadisticasCosto: [],
            estadisticasVenta: [],
            FechaInicio: moment(new Date()).format('YYYY-MM-DD'),
            FechaFin: moment(new Date()).format('YYYY-MM-DD'),
            IdTipoMov: 2,
            idSucursal: 0,
            sucursales: [],
            loading: false,
            error: null,
            loadingSucursales: false,
            dataExcelReport: this.getDataEgresoExportExcel([]),
            excelDataReady: false,
            showHelp: false,
        };
        this.handleFechaInicio = this.handleFechaInicio.bind(this);
        this.handleFechaFin = this.handleFechaFin.bind(this);
        this.onClickGenerarReporte = this.onClickGenerarReporte.bind(this);
        this.handleSavePDF = this.handleSavePDF.bind(this);

    }

    componentDidMount() {
        this.fetchSucursales();
    }

    fetchSucursales = async () => {
        this.setState({ loadingSucursales: true, error: null });

        try {
            const response = await fetch('/api/sucursales/SucursalEmpresa');
            if (!response.ok) {
                throw new Error(`Error en sucursales: ${response.status}`);
            }

            const data = await response.json();
            const sucursales = Array.isArray(data) ? data : [];

            this.setState({
                sucursales,
                idSucursal: sucursales.length > 0 ? Number(sucursales[0].IdSucursal) : 0,
                loadingSucursales: false
            });
        } catch (error) {
            this.setState({ loadingSucursales: false, error: error.message });
        }
    }

    handleFechaInicio(e) {
        let fechaInicio = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD');
        let fechaFin = this.state.FechaFin.length ? this.state.FechaFin : moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        });
    }

    handleFechaFin(e) {
        let fechaInicio = this.state.FechaInicio.length ? this.state.FechaInicio : moment(new Date()).format('YYYY-MM-DD');
        let fechaFin = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        });
    }

    fetchEgresoProductos = async (IdSucursal, FechaInicio, FechaFin, IdTipoMov) => {
        this.setState({loading: true, error: null});

        try {
            const response = await fetch(`/api/movimientosalmacen/productos/egreso/?IdSucursal=${IdSucursal}&FechaInicio=${FechaInicio}&FechaFin=${FechaFin}&IdTipoMov=${IdTipoMov}`);
            
            if (!response.ok) {
                throw new Error(`Error en la solicitud: ${response.statusText}`);
            }

            const data = await response.json();
            
            // Manejar estructura nueva con datos, estadisticasCosto y estadisticasVenta
            let reporteEgreso = [];
            let estadisticasCosto = [];
            let estadisticasVenta = [];
            
            if (data.success && Array.isArray(data.datos)) {
                reporteEgreso = data.datos;
                estadisticasCosto = Array.isArray(data.estadisticasCosto) ? data.estadisticasCosto : [];
                estadisticasVenta = Array.isArray(data.estadisticasVenta) ? data.estadisticasVenta : [];
            } else if (Array.isArray(data)) {
                reporteEgreso = data;
            } else if (Array.isArray(data?.respuesta)) {
                reporteEgreso = data.respuesta;
            }

            this.setState({
                reporteEgreso,
                estadisticasCosto,
                estadisticasVenta,
                loading: false,
                dataExcelReport: this.getDataEgresoExportExcel(reporteEgreso),
                excelDataReady: reporteEgreso.length > 0
            });
        } catch (error) {
            console.error('Error fetching egreso productos:', error);
            this.setState({
                error: error.message,
                loading: false,
                dataExcelReport: this.getDataEgresoExportExcel([]),
                excelDataReady: false,
                reporteEgreso: [],
                estadisticasCosto: [],
                estadisticasVenta: []
            });
        }
    }

    onClickGenerarReporte() {
        const { idSucursal, FechaInicio, FechaFin, IdTipoMov } = this.state;

        if (!idSucursal || Number(idSucursal) === 0) {
            this.setState({ error: 'Debe seleccionar una sucursal' });
            return;
        }

        this.fetchEgresoProductos(idSucursal, FechaInicio, FechaFin, IdTipoMov);
    }

    getNombreSucursal() {
        const sucursal = this.state.sucursales.find(s => Number(s.IdSucursal) === Number(this.state.idSucursal));
        return sucursal ? sucursal.Nombre : 'No especificada';
    }

    sanitizeValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, '');
        }
        return String(value);
    }

    getDataEgresoExportExcel(dataSet) {
        if (!Array.isArray(dataSet) || dataSet.length === 0) {
            return [{
                columns: [
                    { title: 'Nro Movimiento', width: { wpx: 120 } },
                    { title: 'Fecha Movimiento', width: { wpx: 140 } },
                    { title: 'Tipo Transacción', width: { wpx: 180 } },
                    { title: 'Descripción', width: { wpx: 220 } },
                    { title: 'Producto', width: { wpx: 240 } },
                    { title: 'Presentación', width: { wpx: 140 } },
                    { title: 'Cantidad', width: { wpx: 90 } },
                    { title: 'Precio', width: { wpx: 90 } },
                    { title: 'Total', width: { wpx: 90 } },
                    { title: 'Usuario', width: { wpx: 120 } }
                ],
                data: []
            }];
        }

        const data = dataSet.map(row => ([
            { value: this.sanitizeValue(row.Numero) },
            { value: this.sanitizeValue(row.FechaMovimiento ? moment(row.FechaMovimiento).format('DD/MM/YYYY HH:mm') : '') },
            { value: this.sanitizeValue(row.TipoTransaccion) },
            { value: this.sanitizeValue(row.Glosa) },
            { value: this.sanitizeValue(row.Producto) },
            { value: this.sanitizeValue(row.Presentacion) },
            { value: this.sanitizeValue(parseFloat(row.Cantidad || 0).toFixed(2)), style: { alignment: { horizontal: 'right' } } },
            { value: this.sanitizeValue(parseFloat(row.Precio || 0).toFixed(2)), style: { alignment: { horizontal: 'right' } } },
            { value: this.sanitizeValue(parseFloat(row.PrecioVenta || 0).toFixed(2)), style: { alignment: { horizontal: 'right' } } },
            { value: this.sanitizeValue(parseFloat(row.Total || 0).toFixed(2)), style: { alignment: { horizontal: 'right' } } },
            { value: this.sanitizeValue(parseFloat(row.TotalVenta || 0).toFixed(2)), style: { alignment: { horizontal: 'right' } } },
            { value: this.sanitizeValue(row.Usuario) }
        ]));

        return [{
            columns: [
                { title: 'Nro Movimiento', width: { wpx: 120 } },
                { title: 'Fecha Movimiento', width: { wpx: 140 } },
                { title: 'Tipo Transacción', width: { wpx: 180 } },
                { title: 'Descripción', width: { wpx: 220 } },
                { title: 'Producto', width: { wpx: 240 } },
                { title: 'Presentación', width: { wpx: 140 } },
                { title: 'Cantidad', width: { wpx: 90 } },
                { title: 'P. Costo', width: { wpx: 90 } },
                { title: 'P. Venta', width: { wpx: 90 } },
                { title: 'Total Costo', width: { wpx: 90 } },
                { title: 'Total Venta', width: { wpx: 90 } },
                { title: 'Usuario', width: { wpx: 120 } }
            ],
            data
        }];
    }

    handleSavePDF() {
        const { reporteEgreso, FechaInicio, FechaFin, IdTipoMov } = this.state;
        const tipoMovTexto = Number(IdTipoMov) === 1 ? 'INGRESO' : 'EGRESO';

        if (!reporteEgreso || reporteEgreso.length === 0) {
            this.setState({ error: 'No hay datos para exportar a PDF' });
            return;
        }

        try {
            const doc = new jsPDF({
                format: 'a4',
                orientation: 'landscape'
            });

            const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

            doc.setFontSize(16);
            doc.setFont('helvetica', 'bold');
            doc.text(`REPORTE DE ${tipoMovTexto} DE ALMACÉN`, pageWidth / 2, 15, { align: 'center' });

            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text(`Período: ${moment(FechaInicio).format('DD/MM/YYYY')} - ${moment(FechaFin).format('DD/MM/YYYY')}`, 14, 25);
            doc.text(`Sucursal: ${this.getNombreSucursal()}`, 14, 32);

            const dataPdf = reporteEgreso.map(item => ({
                numero: item.Numero || '',
                fechaMovimiento: item.FechaMovimiento ? moment(item.FechaMovimiento).format('DD/MM/YYYY HH:mm') : '',
                tipoTransaccion: item.TipoTransaccion || '',
                glosa: item.Glosa || '',
                producto: item.Producto || '',
                presentacion: item.Presentacion || '',
                cantidad: parseFloat(item.Cantidad || 0).toFixed(2),
                precioCosto: parseFloat(item.Precio || 0).toFixed(2),
                precioVenta: parseFloat(item.PrecioVenta || 0).toFixed(2),
                totalCosto: parseFloat(item.Total || 0).toFixed(2),
                totalVenta: parseFloat(item.TotalVenta || 0).toFixed(2),
                usuario: item.Usuario || ''
            }));

            doc.autoTable({
                body: dataPdf,
                theme: 'grid',
                startY: 40,
                styles: {
                    fontSize: 7,
                    cellPadding: 2,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1
                },
                columnStyles: {
                    numero: { cellWidth: 22 },
                    fechaMovimiento: { cellWidth: 26 },
                    tipoTransaccion: { cellWidth: 28 },
                    glosa: { cellWidth: 32 },
                    producto: { cellWidth: 36 },
                    presentacion: { cellWidth: 22 },
                    cantidad: { cellWidth: 16, halign: 'right' },
                    precioCosto: { cellWidth: 16, halign: 'right' },
                    precioVenta: { cellWidth: 16, halign: 'right' },
                    totalCosto: { cellWidth: 16, halign: 'right' },
                    totalVenta: { cellWidth: 16, halign: 'right' },
                    usuario: { cellWidth: 18 }
                },
                columns: [
                    { header: 'NRO MOV.', dataKey: 'numero' },
                    { header: 'FECHA', dataKey: 'fechaMovimiento' },
                    { header: 'TIPO', dataKey: 'tipoTransaccion' },
                    { header: 'DESC.', dataKey: 'glosa' },
                    { header: 'PRODUCTO', dataKey: 'producto' },
                    { header: 'PRES.', dataKey: 'presentacion' },
                    { header: 'CANT.', dataKey: 'cantidad' },
                    { header: 'P.COSTO', dataKey: 'precioCosto' },
                    { header: 'P.VENTA', dataKey: 'precioVenta' },
                    { header: 'T.COSTO', dataKey: 'totalCosto' },
                    { header: 'T.VENTA', dataKey: 'totalVenta' },
                    { header: 'USUARIO', dataKey: 'usuario' }
                ],
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    fontSize: 8,
                    halign: 'center'
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                }
            });

            doc.setFontSize(8);
            doc.setFont('helvetica', 'italic');
            doc.text(`Generado: ${moment().format('DD/MM/YYYY HH:mm:ss')}`, 14, pageHeight - 10);
            doc.text('Contatrib ERP', pageWidth - 14, pageHeight - 10, { align: 'right' });

            doc.save(`Reporte${tipoMovTexto}Almacen_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
        } catch (error) {
            console.error('Error generando PDF:', error);
            this.setState({ error: 'Error al generar el PDF' });
        }
    }


    render(){
        const {
            reporteEgreso,
            FechaInicio,
            FechaFin,
            IdTipoMov,
            idSucursal,
            sucursales,
            loading,
            error,
            loadingSucursales,
            dataExcelReport,
            excelDataReady,
            showHelp
        } = this.state;

        const tipoMovTexto = Number(IdTipoMov) === 1 ? 'Ingreso' : 'Egreso';

        return (
            <>
              <section className="ventas-fpay-section">
                    <div className="pt-5">
                        <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3">
                            <span className="align-self-center letra-fecha-fpay">Desde: </span>
                            <input
                                type="date"
                                onChange={this.handleFechaInicio}
                                value={FechaInicio}
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            />
                            <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                            <input
                                type="date"
                                onChange={this.handleFechaFin}
                                value={FechaFin}
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            />
                        </div>
                    </div>
                    
                    <div className="container mb-4">
                        <div className="row mb-3 align-items-center">
                            <div className="col-12 col-md-6 mb-2 mb-md-0">
                                <h3 className="mb-0">Reporte Productos de {tipoMovTexto} de Almacén</h3>
                            </div>
                        </div>

                        <div className="mb-3">
                            <div className="caja-fondo-blanco-m-2 col-sm">
                                <label className="sucursal-text-color pad-15-fpay" htmlFor="IdTipoMov">
                                    Tipo de Movimiento
                                </label>
                                <select
                                    name="IdTipoMov"
                                    id="IdTipoMov"
                                    className="form-control"
                                    value={IdTipoMov}
                                    onChange={e => this.setState({IdTipoMov: Number(e.target.value), reporteEgreso: [], excelDataReady: false, dataExcelReport: this.getDataEgresoExportExcel([])})}
                                    disabled={loading}
                                >
                                    <option value={1}>Ingreso</option>
                                    <option value={2}>Egreso</option>
                                </select>
                            </div>
                        </div>
                        
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="mb-3">
                            <div className="caja-fondo-blanco-m-2 col-sm">
                                <label className="sucursal-text-color pad-15-fpay" htmlFor="idSucursal">
                                    Sucursal
                                </label>
                                <select 
                                    name="idSucursal" 
                                    id="idSucursal" 
                                    className="form-control"
                                    value={idSucursal}
                                    onChange={e => this.setState({idSucursal: Number(e.target.value)})}
                                    disabled={loadingSucursales || loading}
                                >
                                    <option value="0">Seleccione una sucursal</option>
                                    {sucursales.map(s => (
                                        <option key={`opt_${s.IdSucursal}`} value={s.IdSucursal}>
                                            {s.Nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        
                        <div className="d-flex justify-content-between mb-3">
                            <button
                                className="btn btn-outline-danger btn-sm mb-2"
                                onClick={() => this.setState({ showHelp: true })}
                                title="Ver guía de uso"
                            >
                                <i className="fas fa-question-circle mr-1"/> HELP
                            </button>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                            <button 
                                className="boton__Rojo mr-2" 
                                onClick={this.handleSavePDF}
                                disabled={!reporteEgreso || reporteEgreso.length === 0}
                                title={!reporteEgreso || reporteEgreso.length === 0 ? 'Genere el reporte primero' : 'Exportar a PDF'}
                            >
                                <i className="fas fa-file-pdf"/>
                            </button>

                            {excelDataReady && reporteEgreso && reporteEgreso.length > 0 ? (
                                <ExcelFile
                                    element={
                                        <button className="boton__verdeOscuro">
                                            <i className="fas fa-file-excel"/>
                                        </button>
                                    }
                                    filename={`Reporte${tipoMovTexto}Almacen_${moment().format('YYYYMMDD_HHmmss')}`}
                                >
                                    <ExcelSheet
                                        dataSet={dataExcelReport}
                                        name={tipoMovTexto}
                                    />
                                </ExcelFile>
                            ) : (
                                <button 
                                    className="boton__verdeOscuro"
                                    style={{opacity: 0.5, cursor: 'not-allowed'}} 
                                    disabled
                                    title="Genere el reporte primero"
                                >
                                    <i className="fas fa-file-excel"/>
                                </button>
                            )}

                            <button 
                                onClick={this.onClickGenerarReporte}
                                className="btn btn-outline-primary btn-verde-mfp"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Generando...
                                    </>
                                ) : (
                                    "Generar"
                                )}
                            </button>
                        </div>

                        <ReporteEgresoStats 
                            reporteEgreso={reporteEgreso} 
                            estadisticasCosto={this.state.estadisticasCosto}
                            estadisticasVenta={this.state.estadisticasVenta}
                            tipoMovTexto={tipoMovTexto} 
                        />
                        
                        <ReactTable
                            id="table-reporte-egreso-almacen"
                            data={reporteEgreso}
                            filterable
                            loading={loading}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id] || '')
                                    .toLowerCase()
                                    .includes(String(filter.value || '').toLowerCase())
                            }
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: "Nro Movimiento",
                                            id: "Numero",
                                            width:130,
                                            accessor: d => d.Numero || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["Numero"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Fecha Movimiento",
                                            id: "FechaMovimiento",
                                            width:110,
                                            accessor: d => d.FechaMovimiento
                                                ? moment(d.FechaMovimiento).format('DD/MM/YYYY HH:mm')
                                                : '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["FechaMovimiento"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Tipo Transacción",
                                            id: "TipoTransaccion",
                                            accessor: d => d.TipoTransaccion || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["TipoTransaccion"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Descripcion",
                                            id: "Glosa",
                                            accessor: d => d.Glosa || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Glosa"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Producto",
                                            id: "Producto",
                                            accessor: d => d.Producto || '',
                                            width: 250,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Producto"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Presentación",
                                            id: "Presentacion",
                                            accessor: d => d.Presentacion || '',
                                            width: 150,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Presentacion"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Cantidad",
                                            id: "Cantidad",
                                            accessor: d => parseFloat(d.Cantidad || 0).toFixed(2),
                                            width: 100,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Cantidad"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "P. Costo",
                                            id: "Precio",
                                            accessor: d => parseFloat(d.Precio || 0).toFixed(2),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Precio"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "P. Venta",
                                            id: "PrecioVenta",
                                            accessor: d => parseFloat(d.PrecioVenta || 0).toFixed(2),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["PrecioVenta"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Total Costo",
                                            id: "Total",
                                            accessor: d => parseFloat(d.Total || 0).toFixed(2),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Total"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Total Venta",
                                            id: "TotalVenta",
                                            accessor: d => parseFloat(d.TotalVenta || 0).toFixed(2),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["TotalVenta"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Usuario",
                                            id: "Usuario",
                                            accessor: d => d.Usuario || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Usuario"]
                                                }),
                                            filterAll: true
                                        }
                                        // {
                                        //     Header: "Sucursal",
                                        //     id: "Sucursal",
                                        //     accessor: d => d.Sucursal || '',
                                        //     filterMethod: (filter, rows) =>
                                        //         matchSorter(rows, filter.value, {
                                        //             keys: ["Sucursal"]
                                        //         }),
                                        //     filterAll: true,
                                        // }
                                    ]
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText={loading ? "Cargando..." : "No se encontraron registros"}
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />
                    </div>
                </section>

                {showHelp && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                    <h5 className="modal-title">
                                        <i className="fas fa-book-open mr-2"/>
                                        Guía: Reporte de Movimientos de Almacén
                                    </h5>
                                    <button
                                        type="button"
                                        className="close text-white"
                                        onClick={() => this.setState({ showHelp: false })}
                                        aria-label="Cerrar"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle mr-2"/>
                                        Esta guía explica el flujo completo del reporte, desde los filtros hasta la exportación.
                                    </div>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-sliders-h mr-2"/>1. Filtros de búsqueda</h6>
                                    <p>Al ingresar al reporte encontrarás en la parte superior un selector de fechas con dos campos <strong>Desde</strong> y <strong>Hasta</strong> que permiten elegir el período a consultar. Ambos campos ya vienen con la fecha actual por defecto.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-exchange-alt mr-2"/>2. Tipo de Movimiento</h6>
                                    <p>Debajo de las fechas hay un selector para elegir el <strong>Tipo de Movimiento</strong>: <em>Ingreso</em> o <em>Egreso</em>. Este valor determina si el reporte mostrará las entradas o salidas de productos del almacén.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-building mr-2"/>3. Selección de Sucursal</h6>
                                    <p>El selector de <strong>Sucursal</strong> se carga automáticamente al montar el componente. Trae todas las sucursales disponibles desde la API y las muestra en un menú desplegable. Debes seleccionar una sucursal antes de generar el reporte.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-play-circle mr-2"/>4. Generar el reporte</h6>
                                    <p>Una vez configurados los filtros, haz clic en el botón <strong>Generar</strong>. El sistema valida que haya una sucursal seleccionada y luego consulta los datos solicitados.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-chart-bar mr-2"/>5. Resultados: Estadísticas y Tabla</h6>
                                    <p>Al recibir los datos se renderizan automáticamente dos elementos:</p>
                                    <ul>
                                        <li><strong>Panel de estadísticas:</strong> muestra gráficos de resumen y el Top 5 de productos (ver detalle en el punto 6).</li>
                                        <li><strong>Tabla detallada:</strong> lista todas las transacciones con columnas de precios duales (<strong>P. Costo</strong>, <strong>P. Venta</strong>, <strong>Total Costo</strong>, <strong>Total Venta</strong>), usuarios responsables, filtros por columna y paginación configurable.</li>
                                    </ul>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-analytics mr-2"/>6. Panel de Análisis Visual (Estadísticas)</h6>
                                    <p>El panel de estadísticas está organizado en tres secciones:</p>

                                    <p><i className="fas fa-th-large mr-1 text-info"/><strong>Tarjetas KPI (parte superior):</strong></p>
                                    <ul>
                                        <li><strong>Movimientos registrados:</strong> cantidad total de líneas de movimiento y número de documentos únicos.</li>
                                        <li><strong>Monto total:</strong> suma de los montos del período consultado con dos perspectivas: <strong>Total Costo</strong> (según precio de costo) y <strong>Total Venta</strong> (según precio de venta), con el promedio por movimiento para cada una.</li>
                                        <li><strong>Unidades totales:</strong> suma de todas las cantidades y promedio de unidades por movimiento.</li>
                                        <li><strong>Tipos de transacción:</strong> cuántos tipos distintos se usaron e indica cuál tiene mayor participación.</li>
                                    </ul>

                                    <p><i className="fas fa-table mr-1 text-info"/><strong>Tabla de Tipos de Transacción (lado izquierdo):</strong></p>
                                    <p>Desglosa cada tipo de transacción mostrando la cantidad de unidades, el monto generado, el porcentaje que representa del total y una barra de progreso para comparar visualmente el peso de cada tipo.</p>

                                    <p><i className="fas fa-trophy mr-1 text-info"/><strong>Top 5 de Productos (lado derecho):</strong></p>
                                    <p>Muestra los cinco productos más relevantes del período. Usa los botones para alternar la vista:</p>
                                    <ul>
                                        <li><strong>Venta:</strong> productos que generaron mayor valor económico (por precio de venta).</li>
                                        <li><strong>Costo:</strong> productos con mayor costo de adquisición (por precio de costo).</li>
                                        <li><strong>Unidades:</strong> productos con mayor cantidad de movimientos.</li>
                                    </ul>
                                    <p>Haz clic en el botón <i className="fas fa-eye"/> de cualquier producto para ver el detalle completo de sus movimientos individuales.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-download mr-2"/>7. Exportación</h6>
                                    <p>Cuando quieras exportar la información tienes dos opciones:</p>
                                    <ul>
                                        <li><span className="badge" style={{backgroundColor:'#c0392b', color:'#fff'}}><i className="fas fa-file-pdf"/> PDF</span> — Genera un documento en formato <em> A4</em> con encabezado, período consultado, nombre de sucursal y la tabla completa.</li>
                                        <li><span className="badge" style={{backgroundColor:'#1e8449', color:'#fff'}}><i className="fas fa-file-excel"/> Excel</span> — Crea un archivo <em>.xlsx</em> con la misma información estructurada en columnas. Ambos botones solo se habilitan cuando hay datos disponibles.</li>
                                    </ul>

                                    <div className="alert alert-secondary mb-0">
                                        <i className="fas fa-lightbulb mr-2 text-warning"/>
                                        <strong>Flujo recomendado:</strong> Elige filtros → Genera → Revisa estadísticas y tabla → Exporta si es necesario.
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => this.setState({ showHelp: false })}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }


}
export default ReporteMovAlmacenProductos;